module.exports = __webpack_public_path__ + "img/color_card_cont_bg.ef7251e2.png";